import { render, staticRenderFns } from "./bindPhoneDialog.vue?vue&type=template&id=0e572c6c&scoped=true"
import script from "./bindPhoneDialog.vue?vue&type=script&lang=js"
export * from "./bindPhoneDialog.vue?vue&type=script&lang=js"
import style0 from "./bindPhoneDialog.vue?vue&type=style&index=0&id=0e572c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e572c6c",
  null
  
)

export default component.exports